import { useCookies } from "react-cookie"
import { ToastContainer, toast } from "react-toastify"
import React, { useState, useEffect, useReducer } from "react"
import "./Home.css"

import Navbar from "../../components/Navbar/Navbar"
import LessonList from "../../components/Lesson/LessonList"

function Home() {
    const [lessons, setLessons] = useState([])
    const [user, setUser] = useState(null)
    const [userPrefs, setUserPrefs] = useState({})
    const [cookies, setCookie] = useCookies(['user-prefs'])

    const loadConsultatii = async () => {
        const url = `${process.env.REACT_APP_API_ROOT}/api/consultation/get?t=${Date.now()}`
        const req = await fetch(url, {
            credentials: "include",
            cache: "no-store",
        })
        if (req.status === 200) {
            const consultatii = await req.json()
            setLessons(consultatii)
        } else if (req.status === 404) {
            setLessons([])
        }
    }

    useEffect(() => {
        if (userPrefs.fetchRequested) {
            ;(async () => {
                await loadConsultatii()
                setUserPrefs({ ...userPrefs, fetchRequested: false })
            })()
        }
    }, [userPrefs.fetchRequested])

    useEffect(() => {
        const loadUser = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_ROOT}/api/user/getUser`, {
                credentials: "include"
            })
            const res = await req.json()
            if (req.status === 200)
                setUser(res)
        }

        const loadUserPrefs = async () => {
            const prefs = {
                useOldList: cookies.useOldList,
                useOldForm: cookies.useOldForm
            }

            setUserPrefs(prefs)
        }

        loadConsultatii()
        loadUser()
        loadUserPrefs()
    }, []);

    const handleLogout = async () => {
        const res = await fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/logout`, {
            method: "GET",
            credentials: "include",
        });

        if (res.ok) {
            window.location.href = "/"
        } else {
            toast.error("Delogare esuata");
        }
    }

    const handleSyncronize = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_ROOT}/api/sheet/sync`, {
                method: "GET",
                credentials: "include",
            });
            toast.success("Sincronizarea a reusit");
            await loadConsultatii()
        } catch (err) {
            console.log(err);
            toast.error("Sincronizarea a esuat")
        }
    }

    const changeUserPrefs = async (prefs) => {
        for (const [key, value] of Object.entries(prefs))
            setCookie(key, value)

        setUserPrefs(prefs)
    }

    return (
        <div className="home">
            <button className="logout-btn" onClick={handleLogout}>
                Logout
            </button>

            <button className="load-btn" onClick={handleSyncronize}>
                Load consultations
            </button>

            <ToastContainer autoClose={5000} />
            <Navbar
                defaultYear="all"
                changeHandler={value => setUserPrefs({ ...userPrefs, visibleYear: value })}
                userLoggedIn={true}
                userPrefs={userPrefs}
                setUserPrefs={changeUserPrefs}
            />

            <LessonList
                lessons={lessons}
                setLessons={setLessons}
                userPrefs={userPrefs}
                setUserPrefs={setUserPrefs}
            />
        </div>
    );
}

export default Home;
